import { memo, useEffect, useRef } from "react";

/** Keeps SVG animations from restarting when unrelated UI state (e.g. save status) re-renders. */
export const TurtleStage = memo(function TurtleStage({ html }: { html: string }) {
  const hostRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const host = hostRef.current;
    if (!host || host.innerHTML === html) return;
    host.innerHTML = html;
  }, [html]);

  return (
    <div
      ref={hostRef}
      className="ide-turtle-stage"
      aria-label="Turtle drawing"
    />
  );
});
